<template>
    <footer class="footer">
        <p class="has-text-centered">Copyright (c) 2023</p>
    </footer>
</template>
